import {
  UPDATE_SUBPRACTICE_INFO,
  UPDATE_SUBPRACTICE_INFO_SUCCESS,
  UPDATE_SUBPRACTICE_INFO_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const updateSubpracticeInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SUBPRACTICE_INFO:
      return { ...state, loading: true };
    case UPDATE_SUBPRACTICE_INFO_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case UPDATE_SUBPRACTICE_INFO_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default updateSubpracticeInfoReducer;
